module.exports = "<div id=\"srmBlockDiv\" class=\"modal\" style=\"background-color: rgb(250,250,250); opacity: 0.4\"></div>\r\n<div id=\"srmBusyLoader\" class=\"modal center-loader\">\r\n\t\t<img align=\"middle\" src='./assets/img/ajax-loader.gif' style=\"vertical-align: middle;\"/> \r\n\t\t<span>&nbsp; Attendere</span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/busy/busy.component.html
// module id = 442
// module chunks = 0